import { render, staticRenderFns } from "./agregarTransferencia.vue?vue&type=template&id=118a44ca"
import script from "./agregarTransferencia.vue?vue&type=script&lang=js"
export * from "./agregarTransferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports